import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message, Select, InputNumber } from "antd";
import { BASE_URL } from "../constants/Constants";
import axios from "axios";

const { Option } = Select;

const AddCouponForm = ({ visible, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();
  const [categories, setCategories] = useState([]);

  // Fetch Categories for the dropdown
  useEffect(() => {
    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/category/all-unhide`);
            setCategories(res.data || []);
        } catch (err) {
            console.error("Failed to load categories", err);
        }
    };
    if(visible) fetchCategories();
  }, [visible]);

  const handleAddCoupon = async () => {
    try {
      const values = await form.validateFields();
      
      const payload = {
          ...values,
          couponStatus: "active",
          isMain: false, // ➤ CHANGED: Forced to false
          productId: values.scope === 'PRODUCT' ? values.productId : null,
          categoryId: values.scope === 'CATEGORY' ? values.categoryId : null,
      };

      if (initialValues) {
        onSubmit(payload, initialValues._id);
        return;
      }

      await axios.post(`${BASE_URL}/api/coupons`, payload);

      message.success("Coupon added successfully");
      form.resetFields();
      onClose();
      window.location.reload();
    } catch (error) {
      console.log(error);
      message.error("Failed to add coupon");
    }
  };

  useEffect(() => {
    if (initialValues) {
        form.setFieldsValue(initialValues);
    } else {
        form.resetFields();
        form.setFieldsValue({ scope: 'ALL', couponType: '%' });
    }
  }, [initialValues, form, visible]);

  return (
    <Modal
      title="Add New Coupon"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button key="add" type="primary" onClick={handleAddCoupon}>Add Coupon</Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Coupon Code"
          name="couponName"
          rules={[{ required: true, message: "Please enter unique code" }]}
        >
          <Input style={{ textTransform: 'uppercase' }} placeholder="e.g. SUMMER50" />
        </Form.Item>

        <div style={{ display: 'flex', gap: '16px' }}>
            <Form.Item
              label="Type"
              name="couponType"
              style={{ flex: 1 }}
              rules={[{ required: true }]}
            >
              <Select>
                <Option value="%">Percentage (%)</Option>
                <Option value="Rs">Flat Amount (₹)</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Value"
              name="couponValue"
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Enter value" }]}
            >
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
        </div>

        <Form.Item
          label="Minimum Order Amount (₹)"
          name="minOrderAmount"
          help="Leave empty if no minimum is required"
        >
          <InputNumber style={{ width: '100%' }} min={0} placeholder="e.g. 500" />
        </Form.Item>

        {/* --- SCOPE SELECTION --- */}
        <Form.Item
            label="Applies To"
            name="scope"
            rules={[{ required: true }]}
            initialValue="ALL"
        >
            <Select>
                <Option value="ALL">All Products</Option>
                <Option value="PRODUCT">Specific Product</Option>
                <Option value="CATEGORY">Specific Category</Option>
            </Select>
        </Form.Item>

        {/* --- CONDITIONAL INPUTS --- */}
        <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => prevValues.scope !== currentValues.scope}
        >
            {({ getFieldValue }) => 
                getFieldValue('scope') === 'PRODUCT' ? (
                    <Form.Item 
                        label="Product ID" 
                        name="productId" 
                        rules={[{ required: true, message: "Please enter Product ID" }]}
                    >
                        <Input placeholder="Enter Product ID (e.g. 101)" />
                    </Form.Item>
                ) : getFieldValue('scope') === 'CATEGORY' ? (
                    <Form.Item 
                        label="Select Category" 
                        name="categoryId" 
                        rules={[{ required: true, message: "Please select a category" }]}
                    >
                        <Select placeholder="Choose a category">
                            {categories.map(cat => (
                                <Option key={cat.categoryId} value={cat.categoryId}>
                                    {cat.categoryName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : null
            }
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default AddCouponForm;